import { Color, Flex, FormItemsGroup, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceComplianceMode } from '@features/invoices/hooks/useInvoiceComplianceMode'
import { shouldAllowVatNumberWhenExempt } from '@features/invoices/utils/shouldAllowVatNumberWhenExempt'
import { useZervantSettings } from '@features/invoicingSettings/hooks/useZervantSettings'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useMissingCompanyDetailsForm } from '../../../../contexts/missingCompanyDetailsFormContext'
import { getMissingCompanyIdErrorMessage } from '../../../../utils/getMissingCompanyIdErrorMessage'
import { CompanyRegistrationNumber } from './elements/CompanyRegistrationNumber'
import { CompanyVatNumber } from './elements/CompanyVatNumber'

export const CompanyTaxInfoSection = (): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const {
    missingCompanyDetailsForm: {
      formState: { errors },
    },
  } = useMissingCompanyDetailsForm()
  const { data: zervantSettings } = useZervantSettings()
  const { isFrenchComplianceMode } = useInvoiceComplianceMode()

  const { registrationNo: registrationNoError, vatNo: vatNoError } = errors || {}
  const shouldShowVatNumberField =
    !organization?.isVatExempted || shouldAllowVatNumberWhenExempt(organization?.countryId)
  const shouldShowCompanyRegistrationNumberField =
    !isFrenchComplianceMode || !zervantSettings?.values?.company?.legalFormSettings?.isSiretPendingAssignment

  // For countries other than FR we show this error message when both fields are missing because we need at least one
  const shouldShowMissingCompanyIdErrorMessage = !isFrenchComplianceMode && registrationNoError && vatNoError
  const missingCompanyIdErrorMessage = getMissingCompanyIdErrorMessage(organization?.countryId, t)

  return (
    <Flex flexDirection="column" gap={Spacing.S4}>
      <FormItemsGroup>
        {shouldShowCompanyRegistrationNumberField && <CompanyRegistrationNumber />}
        {shouldShowVatNumberField && <CompanyVatNumber />}
      </FormItemsGroup>
      {shouldShowMissingCompanyIdErrorMessage && (
        <Text color={Color.Red700} variant="bodySM">
          {missingCompanyIdErrorMessage}
        </Text>
      )}
    </Flex>
  )
}
